import { FC } from 'react';
import { Subtitle } from 'src/shared';
import color from 'src/theme/color';
import { Box, Typography } from '@mui/material';
import { QuestSchema } from 'src/types/quests';

interface QuestTitleProps {
    quest: QuestSchema;
}

const QuestTitle: FC<QuestTitleProps> = ({ quest }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
                <Box sx={{ flex: 2 }}>
                    <Box>
                        <Subtitle>Request Title</Subtitle>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            marginTop: '3px'
                        }}
                    >
                        <Typography variant="h6" sx={{ color: color.white }}>
                            {quest?.title || 'Request Title Not Found'}
                        </Typography>
                    </Box>
                </Box>

                <Box sx={{ flex: 1 }}>
                    <Box>
                        <Subtitle>Request ID </Subtitle>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            marginTop: '3px'
                        }}
                    >
                        <Typography variant="h6" sx={{ color: color.white }}>
                            {quest?.id}
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default QuestTitle;
